import {
  GET_PAGE_NUMBER,
  SET_PAGE_NUMBER,
  GET_PAGINATOR,
  UPDATE_PAGINATOR,
  SET_ITEMS_PER_PAGE,
  GET_ITEMS_PER_PAGE,
} from './constants';

/**
 *
 * @returns {{type: *}}
 */
export const getPage = () => ({
  type: GET_PAGE_NUMBER,
});

/**
 *
 * @param pageNumber
 * @returns {{page: *, type: *}}
 */
export function setPage(pageNumber) {
  return {
    type: SET_PAGE_NUMBER,
    pageNumber,
  };
}

/**
 *
 * @returns {{type: *}}
 */
export const getPaginator = () => ({
  type: GET_PAGINATOR,
});

/**
 *
 * @param total
 * @param lastPage
 * @param currentPage
 * @returns {{total: *, lastPage: *, type: *, currentPage: *}}
 */
export function updatePaginator(total, lastPage, currentPage) {
  return {
    type: UPDATE_PAGINATOR,
    total,
    lastPage,
    currentPage,
  };
}

/**
 *
 * @returns {{type: *}}
 */
export const getItemsPerPage = () => ({
  type: GET_ITEMS_PER_PAGE,
});

/**
 *
 * @param itemsPerPage
 * @returns {{itemsPerPage: *, type: *}}
 */
export function setItemsPerPage(itemsPerPage) {
  return {
    type: SET_ITEMS_PER_PAGE,
    itemsPerPage,
  };
}
